import React, { useEffect, useState } from 'react'
import classNames from 'classnames';
import { validate } from './validations';

const TextField = (props) => {

  let {
    label,
    name,
    type,
    id,
    klassname,
    placeholder,
    error,
    onChange,
    onKeyPress,
    onErrorStateChange,
    validations = [],
    initialValue = '',
    ...rest
  } = props;

  useEffect(() => {
    SetError(error);
  }, [error])

  if (error == 'is already taken') {
    error = <>already exists. <a href='/login'>Log in instead</a></>;
  }

  const [ Error, SetError ] = useState(error);

  const handleBlur = e => {
    const error = validate(e.target.value, validations);
    SetError(error);
    if (onErrorStateChange) {
      onErrorStateChange(e, error);
    }
  }

  return (
    <label htmlFor={id} className={classNames({'has_error': Error, [klassname]: true})}>
      {label}&nbsp;
      { Error && <span className='error'>{typeof Error === 'string' ? Error.charAt(0).toUpperCase() + Error.slice(1) : Error}</span> }
      <input
        id={id}
        type={type}
        name={name}
        onBlur={handleBlur}
        onKeyPress={onKeyPress}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={initialValue}
        {...rest}
      />
    </label>
  )
}

export default TextField;